var _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScroll(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.397 39.8713L49.5236 35.685L51.2517 35.892C52.2634 35.1733 51.9571 31.8541 51.8204 30.6213L50.1845 15.8467C50.0478 14.6147 49.2775 14.3776 48.4728 15.3213L45.14 19.2291C44.3349 20.1729 43.8517 21.9451 44.0665 23.167L45.2896 30.1463L34.2646 28.0463C33.045 27.8143 32.7384 28.369 33.5794 29.2795L42.945 39.7397C44.5052 39.6651 45.6552 40.8655 46.397 39.8713Z",
    fill: "url(#paint0_linear_29579_2456)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4656 98.6172C30.3391 94.5086 82.3164 8.17973 82.3164 8.17973L75.3383 1.30161C75.3383 1.30161 74.6586 0.953951 74.327 1.42348C72.1559 4.50825 58.5871 27.727 42.0574 41.0122C24.3609 55.234 22.8246 60.2516 0.83828 74.2164C0.42305 74.4805 0.16758 75.2528 0.662888 76.1122C2.41875 79.159 20.516 101.204 27.4656 98.6172Z",
    fill: "url(#paint1_linear_29579_2456)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M15.6461 79.9474C15.6461 79.9474 3.80234 79.9032 3.82617 79.9474C3.85156 80.1099 3.88008 80.2641 3.90664 80.4235C9.84883 87.6743 22.0457 100.634 27.4648 98.6173V95.8243L15.6461 79.9474Z",
    fill: "url(#paint2_linear_29579_2456)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M85.1883 1.17774C85.3766 0.996486 98.4512 4.99727 99.6094 16.2383C99.6094 16.2383 54.4414 59.5106 27.4652 98.6172C27.4652 98.6172 21.7691 87.1395 4.17734 80.1762C3.73788 80.0016 3.6371 79.7895 4.01991 79.491C26.9047 61.6656 35.5703 51.1578 45.7172 40.616C56.0344 29.8977 84.9988 1.3586 85.1883 1.17774Z",
    fill: "url(#paint3_linear_29579_2456)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M53.4532 32.7295C50.4055 35.8018 47.7106 38.5432 45.7149 40.6162C45.468 40.8725 45.2231 41.1287 44.9774 41.385C50.3981 43.5357 62.0879 49.001 61.5989 55.9799L61.6325 55.9432C64.9297 52.2389 68.2642 48.568 71.6356 44.9311C72.6059 42.7678 66.1047 35.1811 53.4532 32.7295Z",
    fill: "#2C2C2C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M51.9433 31.7129L42.9425 39.7395C42.9425 39.7395 62.6609 46.4297 62.0261 55.5023C62.1351 55.6656 69.9718 47.0027 72.1543 44.4965C73.8168 42.5859 66.5086 33.7305 51.9433 31.7129Z",
    fill: "url(#paint4_linear_29579_2456)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_29579_2456",
    x1: 53.1357,
    y1: 28.7475,
    x2: 33.9306,
    y2: 24.5725,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F0024"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8F0024"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_29579_2456",
    x1: 41.3535,
    y1: 1.17778,
    x2: 41.3535,
    y2: 98.8278,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4AA6D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#328EBB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_29579_2456",
    x1: 15.6453,
    y1: 79.9274,
    x2: 15.6453,
    y2: 98.8278,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#367899"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#236281"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_29579_2456",
    x1: 61.6896,
    y1: 54.757,
    x2: 48.259,
    y2: 42.3506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2E2E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_29579_2456",
    x1: 65.3886,
    y1: 46.8309,
    x2: 50.5617,
    y2: 38.4646,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F0024"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8F0024"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScroll);
export default __webpack_public_path__ + "static/media/scroll.4c31ff991e403b233cc76a09310fd2ac.svg";
export { ForwardRef as ReactComponent };